import { render, staticRenderFns } from "./KnInventoryMovements.vue?vue&type=template&id=24094a92"
import script from "./KnInventoryMovements.js?vue&type=script&lang=js&external"
export * from "./KnInventoryMovements.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports